import React, { useState } from "react";
import "./getDemoRequest.css";
import getDemoRequestGif from "assets/getDemoRequest/getDemoRequest.gif";
import { postQuery } from "api";
import { API_DEMO_REQUEST } from "utils/apiEndPoints";
import Meta from "utils/meta";
import CountryCodeList from "utils/countryCode";

const GetDemoRequest = () => {
  const [errors, setErrors] = useState({});
  const [popup, setPopup] = useState({ message: "", type: "", visible: false });
  const [isSubmitPopupMessage, setIsSubmitPopupMessage] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [getRequestFormData, setGetRequestFormData] = useState({
    full_name: "",
    email: "",
    country_code: "+91",
    phone_number: "",
    company: "",
  });

  const getRequestFormDataValidation = () => {
    const newErrors = {};
    if (!getRequestFormData.full_name) {
      newErrors.full_name = "Name is required.";
    }
    if (!getRequestFormData.phone_number || !/^\d{10}$/.test(getRequestFormData.phone_number)) {
      newErrors.phone_number = "Please enter a valid 10-digit mobile number.";
    }
    if (!getRequestFormData.email) {
      newErrors.email = "Email is required.";
    } else if (!getRequestFormData.email || !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(getRequestFormData.email)) {
      newErrors.email = "Please enter a valid email address.";
    }
    if (!getRequestFormData.company) {
      newErrors.company = "Position in Company is required";
    }
    return newErrors;
  };

  const handleGetRequestInput = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setGetRequestFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleSubmitRequest = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const getRequestValidationErrors = getRequestFormDataValidation();
    if (Object.keys(getRequestValidationErrors).length > 0) {
      setErrors(getRequestValidationErrors);
      setIsLoading(false);
      return false;
    }
    const getRequestData = {
      ...getRequestFormData,
      message: "",
    };
    try {
      const getRequestResponse = await postQuery(API_DEMO_REQUEST, getRequestData);
      if (getRequestResponse?.data?.success === 1) {
        setGetRequestFormData({
          full_name: "",
          email: "",
          country_code: "",
          phone_number: "",
          company: "",
          message: "",
        });
        showPopup("Thank you for reaching out! We have received your message and will get back to you as soon as possible!");
        setIsSubmitPopupMessage(true);
        setIsLoading(false);
      } else {
        showPopup("Failed to submit the request. Please try again!");
        setIsSubmitPopupMessage(true);
        setIsLoading(false);
        return false;
      }
    } catch (error) {
      setIsLoading(false);
      setErrors({getRequest: "An error occurred. Please try again later."});
      return false;
    }
  };

  const showPopup = (message, type) => {
    setPopup({ message, type, visible: true });
    setTimeout(() => {
      setPopup({ message: "", type: "", visible: false });
      setIsSubmitPopupMessage(false);
    }, 5000);
  };

  const handleCloseDemoRequest = (e) => {
    e.preventDefault();
    setIsSubmitPopupMessage(false);
  };

  return (<>
      <Meta title="Get Demo Request | The Realtor Desk" description="" />
      <div className="sub-page--outer demo-request--page">
        <div className="container">
          <h2>Request a Demo</h2>
          <p>Transform your business with The Realtor Desk CRM!</p>
          <p>Book a demo and our team will demonstrate how The Realtor Desk CRM is priceless for your business.</p>
          <div className="demo-request--form-outer">
            <div className="getRequestDemo-image">
              <img src={getDemoRequestGif} alt="Demo Request" />
            </div>
            <div className="form-container">
              <form
                className="registration-form"
                onSubmit={handleSubmitRequest}
                method="POST"
                encType="multipart/form-data"
                noValidate
              >
                <div className={`form-row ${errors.full_name ? "input-error" : ""}`}>
                  <label htmlFor="full_name">
                    <div>Full Name<span style={{ color: "red" }}>*</span></div>
                    {errors.full_name && (
                        <div className="tooltip">
                          <span className="tooltip-icon"><i className="fa fa-exclamation-circle" /></span>
                          <div className="tooltip-text">{errors.full_name}</div>
                        </div>
                    )}
                  </label>
                  <input
                    type="text"
                    name="full_name"
                    value={getRequestFormData.full_name}
                    onChange={handleGetRequestInput}
                    required
                    placeholder="Enter your full name"
                  />
                </div>
                <div className={`form-row ${errors.email ? "input-error" : ""}`}>
                  <label htmlFor="email">
                    <div>Email<span style={{ color: "red" }}>*</span></div>
                    {errors.email && (
                        <div className="tooltip">
                          <span className="tooltip-icon"><i className="fa fa-exclamation-circle" /></span>
                          <div className="tooltip-text">{errors.email}</div>
                        </div>
                    )}
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={getRequestFormData.email}
                    onChange={handleGetRequestInput}
                    required
                    placeholder="Enter your email"
                  />
                </div>
                <div className={`form-row ${errors.phone_number ? "input-error" : ""}`}>
                  <label htmlFor="contact_no">
                    <div>Contact Number<span style={{color: "red"}}>*</span></div>
                    {errors.phone_number && (
                        <div className="tooltip">
                          <span className="tooltip-icon"><i className="fa fa-exclamation-circle" /></span>
                          <div className="tooltip-text">{errors.phone_number}</div>
                        </div>
                    )}
                  </label>
                  <div className="country-code-phone-wrapper">
                    <div className="country-code-wrapper select-wrapper">
                      <select
                          name="country_code"
                          value={getRequestFormData.country_code}
                          onChange={handleGetRequestInput}
                          required
                      >
                        {CountryCodeList.map((countryCodes) => (
                            <option key={countryCodes.id} value={countryCodes.code}>
                              {countryCodes.code}
                            </option>))}
                      </select>
                    </div>
                    <input
                        type="tel"
                        name="phone_number"
                        placeholder="Enter your phone number"
                        minLength="10"
                        maxLength="10"
                        value={getRequestFormData.phone_number}
                        onChange={handleGetRequestInput}
                        required
                        className="reg-contact-no"
                        onKeyPress={(e) => {
                          if (!/[0-9]/.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                    />
                  </div>
                </div>
                <div className={`form-row ${errors.company ? "input-error" : ""}`}>
                  <label htmlFor="company">
                    <div>Position in Company <span style={{ color: "red" }}>*</span></div>
                    {errors.company && (
                        <div className="tooltip">
                          <span className="tooltip-icon"><i className="fa fa-exclamation-circle" /></span>
                          <div className="tooltip-text">{errors.company}</div>
                        </div>
                    )}
                  </label>
                  <input
                    type="text"
                    name="company"
                    value={getRequestFormData.company}
                    onChange={handleGetRequestInput}
                    required
                    placeholder="Enter position in company"
                  />
                </div>
                <button className="registrationFrom-next-btn primary" type="submit" disabled={isLoading}>
                  {isLoading ? (<span className="spinner"></span>) : 'Submit'}
                </button>
              </form>
              {isSubmitPopupMessage && (
                <div className={`getDemoRequestPopup ${popup.type}`}>
                  <button className="close-btn" onClick={handleCloseDemoRequest}>
                    X
                  </button>
                  {popup.message}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GetDemoRequest;
